export default __webpack_public_path__ + "static/media/06.1b3e48c7.jpg";